export type { MeeAttendance, MeePerson, MeeRequest, RequestStatus, RequestType } from './types';
export {
  ATTENDANCE, BOARD_NOW, BOARD_TODAY, LEAVE_YEAR_FROM, MEE_CLIENT_INFO, PEOPLE, REQUESTS, meeCalendar,
} from './fixtures';
export { meeApiRoutes, leaveFromApi, statusFromApi, mergeLeave } from './apiRoutes';
export { dayRecord, leaveBalance, leaveDays, otHours, presenceBetween, type DayRecord, type DayStatus, type LeaveBalance } from './logic';

import { ATTENDANCE, PEOPLE, REQUESTS } from './fixtures';

/** Nạp dữ liệu mẫu Mee: `fixtures: registerMeeFixtures` của zone. */
export function registerMeeFixtures(register: (entity: string, rows: readonly unknown[]) => void): void {
  register('meePerson', PEOPLE);
  register('meeRequest', REQUESTS);
  register('meeLeaveMine', REQUESTS.filter((r) => r.type === 'leave' && r.owner === 'DAVID'));
  register('meeLeaveTeam', REQUESTS.filter((r) => r.type === 'leave' && PEOPLE[0]!.team.includes(r.owner)));
  register('meeAttendance', ATTENDANCE);
}
